import axios from 'axios';
import AppConfig from '../../AppConfig';
import { axiosBaseConfig, setupInterceptors } from './baseAxiosInstance';

const ordersAxiosInstance = axios.create({
  ...axiosBaseConfig,
  baseURL: AppConfig.OMS_BASE_URL as string,
});

setupInterceptors(ordersAxiosInstance);

export default ordersAxiosInstance;
